import React from "react";
import { FxDashEditInfo } from "./FxDashBoard";

export const FxContentBox = (props) => {

  const { fxUiGrp, fxUiGrpItem, editable } = props;

  console.log('*** FxContentBox ***', props.children);

  if (editable) {
    return <FxDashEditInfo>컨텐츠박스</FxDashEditInfo>;
  }

  return <>
    <div id='fxmsContentComponentDiv' className='FxContentBox'>
      {props.children ?
        <div id='fxmsContentComponentDivChild' className='FxContentBoxContent' >
          {props.children}
        </div>
        : ""}
    </div>
  </>

};


export default FxContentBox;
